import React from "react";
import Image, { ImageProps } from "next/future/image";

const DEFAULT_QUALITY_SCORE = 90;
export interface IAppImage extends ImageProps {
  isLCP?: boolean;
}

export const AppImage = React.memo(
  ({ alt, src, isLCP = false, ...props }: IAppImage) => {
    return (
      <Image
        src={src}
        width={0}
        height={0}
        sizes="100vw"
        alt={alt || ""}
        fill={true}
        priority={isLCP}
        quality={DEFAULT_QUALITY_SCORE}
        {...props}
      />
    );
  }
);

export default AppImage;
